import { render } from "./deposit_bk.vue?vue&type=template&id=a777e742&scoped=true"
import script from "./deposit_bk.vue?vue&type=script&lang=js"
export * from "./deposit_bk.vue?vue&type=script&lang=js"

import "./deposit_bk.vue?vue&type=style&index=0&id=a777e742&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\forex\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a777e742"]])

export default __exports__